import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheGlobalPulse from "./sections/TheGlobalPulse";
import EngineeredForExcellence from "./sections/EngineeredForExcellence";
import RecentMasterpieces from "./sections/RecentMasterpieces";
import PlatformCapabilitiesCarousel from "./sections/PlatformCapabilitiesCarousel";
import TheGlobalEconomicGraph from "./sections/TheGlobalEconomicGraph";
import IndustryRecognition from "./sections/IndustryRecognition";
import InitiateCollaboration from "./sections/InitiateCollaboration";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TheGlobalPulse />
      <EngineeredForExcellence />
      <RecentMasterpieces />
      <PlatformCapabilitiesCarousel />
      <TheGlobalEconomicGraph />
      <IndustryRecognition />
      <InitiateCollaboration />
      <Footer />
    </div>;
}